<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup" :retain-focus="false">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div>
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mt-6">
          <label class="label-input">Image</label>
          <div class="group-item">
            <v-row class="mb-4">
              <v-col cols="6">
                <v-select v-model="fields.image.position" :items="postionOptions" label="Image Position" hide-details />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="fields.image.width"
                  type="number"
                  label="Width"
                  min="0"
                  max="100"
                  suffix="%"
                  hide-details
                />
              </v-col>
            </v-row>
            <UploadImage
              :image="{ imageSrc: fields.image.url }"
              :height="`150`"
              :typeUpload="'image'"
              @callback="handleUploadImage"
              @callbackDelete="handleRemoveUpload"
              label="Image"
            />
          </div>
        </div>

        <div class="mt-6">
          <label class="label-input">Content</label>
          <ckeditor :editor="editor" v-model="fields.content" :config="editorConfig" />
        </div>

        <div class="mt-6">
          <label class="label-input">Section Settings</label>
          <div class="group-item">
            <div>
              <div class="font-weight-medium">Spacing</div>
              <v-row>
                <v-col cols="6">
                  <v-checkbox v-model="fields.topPadding" label="Top Padding" dense hide-details />
                </v-col>
                <v-col cols="6">
                  <v-checkbox v-model="fields.bottomPadding" label="Bottom Padding" dense hide-details />
                </v-col>
              </v-row>
            </div>
            <div class="mt-6">
              <div class="font-weight-medium mb-3 mb-2">Container Colors</div>
              <v-row>
                <v-col md="6" cols="12">
                  <ColorPicker
                    v-model="fields.colors.backgroundColor"
                    name="backgroundColor"
                    label="Background Color"
                    default-color="#14A16C"
                  />
                </v-col>
                <v-col md="6" cols="12">
                  <ColorPicker
                    v-model="fields.colors.textColor"
                    name="textColor"
                    label="Text Color"
                    default-color="#ffffff"
                  />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import ColorPicker from './common/color-picker.vue';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';

export default {
  name: 'card-basic-section-editor',
  components: {
    UploadImage,
    ColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      postionOptions: [
        {
          text: 'Left',
          value: 'left',
        },
        {
          text: 'Right',
          value: 'right',
        },
      ],
      fields: {
        title: 'Card Basic Section',
        enableAnchor: false,
        colors: {
          backgroundColor: '#14A16C',
          textColor: '#ffffff',
        },
        content: '',
        topPadding: true,
        bottomPadding: true,
        image: {
          position: 'left',
          width: 30,
          url: '',
        },
      },
    };
  },
  computed: {},
  mounted() {
    if (this.sectionEditor.sectionExtract) {
      this.fields = {
        ...this.fields,
        ...this.sectionEditor.sectionExtract,
      };
    }
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal.sectionExtract) {
          this.fields = {
            ...this.fields,
            ...newVal.sectionExtract,
          };
        }
      },
      deep: true,
    },
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardBasic(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadImage(obj) {
      this.fields.image.url = obj.imageSrc;
    },
    handleRemoveUpload() {
      this.fields.image.url = '';
    },
  },
};
</script>

<style scoped lang="scss">
.ck-editor__editable {
  min-height: 100px;
}
.thumbnail-text {
  flex: 1;
  p {
    margin: 0 !important;
  }
}
.item-thumbnail {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
